<template>
    <div class="parent-container">
        <!-- <div class="content">
            <div class="service-provide-info">
                <div class="container text-center">
                    <h1 class="custom-text-color">Survey Completed</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="submit">
                        <button type="button" class="btn sub-main" @click="hispec()">Close</button>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var { redirectUrl, frontHostName } = require("../../../config/config.js");
export default {
  name: "Thankyou",
  metaInfo() {
    return {
      title: this.siteTitle,
    };
  },
  props: ["siteTitle", "isLoopSurvey"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("previewSurvey", ["addResponseStatus"])
  },
  mounted() {
    // Added By Parimal A. Ghadiyali - 16th April 2021
    // As getting can't read property 'blur' of undefined in IE so we need to first active body element
    var bodyElement = document.querySelector("body");
    if(bodyElement.setActive) {
      bodyElement.setActive(); // For IE
    } else {
      if(bodyElement.focus) {
        bodyElement.focus(); // For other browsers
      }
    }
    this.$awn.modal(
      '<img src="/static/images/imgpsh_fullsize_anim.png" alt="...">',
      'custom-modal',
    );

    setTimeout(() => {
      // Reload current page if loop survey is enabled
      if (this.isLoopSurvey == 1) window.location.reload();
      else
        this.hispec(); // Close the tab
    }, 3000);
    // END

    if (this.addResponseStatus.flag == 1) {
      this.$awn.success("Form is submitted!");
    } else if (
      this.addResponseStatus.flag == 2 ||
      this.addResponseStatus.flag == 3
    ) {
      this.$awn.alert(
        this.addResponseStatus.errorDetails +
          ": There was some error in submitting repsponse. Please submit response again."
      );
    } else if (this.addResponseStatus.flag == 0) {
      this.$awn.alert(
        "There was some error in submitting repsponse. Please submit response again."
      );
    }
  },
  methods: {
    hispec() {
      if (!window.close()) {
        // var parts = window.location.href.split(".");
        let whitelabel = this.$session.get("whitelabel");
        var loc =
          frontHostName +
          process.env.CAKE_BASE_PATH +
          whitelabel +
          process.env.CAKE_SURVEY_PATH;
        window.location.href = loc;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Preview/Thankyou.vue